import { LineSegment } from "../../core/geo/types";
import { isNotEmptyArray } from "../../core/utils/array";
import { PortalLineSegment } from "./types";
import { populateGeoBorderSegmentCoordinates } from "../../common/util/draw/geo-border/geoBorderCoordinates";

export const processSegments = async (
    segments: PortalLineSegment[] | undefined,
    envParams: string
): Promise<LineSegment[]> => {
    if (isNotEmptyArray(segments)) {
        //TODO: MSA - send only geoborder segments as parameter and then replace them in segments
        return (await populateGeoBorderSegmentCoordinates(
            sortSegments(segments),
            envParams
        )) as unknown as LineSegment[];
    }
    return [];
};

const sortSegments = (segments: PortalLineSegment[]) => {
    return segments!.sort((segment, segment2) => segment.properties.index - segment2.properties.index);
};
